<template>
  <v-container>
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="70"
        color="primary"
      ></v-progress-circular>
    </v-overlay>

    <v-row justify="center">
      <v-col cols="12" lg="8" md="8" sm="8">
        <v-card elevation="0">
          <v-row>
            <v-col cols="12">
              <span class="display-1 font-weight-black  text-uppercase">
                {{ news.title }}
              </span>
              <br />
              <hr />
              <span>{{ news.created | date }}</span>
              <hr />
            </v-col>
            <v-col cols="12">
              <img
                width="100%"
                height="auto"
                :src="images.length != 0 ? images[0].url : imageLocal"
              />
            </v-col>
            <v-col cols="12">
              <p v-html="news.content"></p>

              <youtube
                v-if="news.link && isYoutube"
                player-width="100%"
                :video-id="reproduceVideo(news.link)"
              ></youtube>

              <!-- Your embedded video player code -->
              <v-row v-else>
                <v-col cols="12">
                  <div id="fb-root"></div>

                  <div
                    class="fb-video"
                    v-show="news.link && isYoutube == false"
                    :data-href="reproduceVideoF(news.link)"
                    data-show-text="false"
                    data-allowfullscreen="true"
                  ></div>
                </v-col>
              </v-row>
              <div>
                <div>
                  <Twitter :url="baseUrl" scale="2" class="sharedIcon" />

                  <Facebook :url="baseUrl" class="ml-3 sharedIcon" scale="2" />
                  <WhatsApp :url="baseUrl" class="ml-3 sharedIcon" scale="2" />
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { firebase, news, storage } from "../../firebase.config";
import { formatDateNew } from "../../filters";
import { Twitter, Facebook, WhatsApp } from "vue-socialmedia-share";
import { getIdFromURL, getTimeFromURL } from "vue-youtube-embed";
export default {
  filters: {
    date(value) {
      return formatDateNew(value);
    },
  },
  components: {
    Twitter,
    Facebook,
    WhatsApp,
  },
  props: ["id"],
  data: () => ({
    imageLocal: "https://cdn.vuetifyjs.com/images/cards/docks.jpg",
    images: [{}, {}, {}],
    isYoutube: false,
    baseUrl: "https://www.telemontv.com/newsDetail/",
    urlF: "",
    news: {
      link: "",
      active: true,
      content: `<h2>Este es el contenido de la noticia</h2><p>Puede especificar cualquier formato que desee, utilizando los componentes que se encuentran en la barra más arriba.</p>`,
    },
    overlay: false,
  }),

  beforeMount() {
    if (!this.isNew) {
      this.loadNews();
    }
  },
  mounted() {
    if (!this.isNew) {
      this.baseUrl = this.baseUrl + this.id;
      // this.loadNews();
      this.init();
    }
  },

  methods: {
    async init() {
      await this.loadFacebookSDK(document, "script", "facebook-jssdk");
      await this.initVideo();
    },
    async initVideo() {
      window.fbAsyncInit = function() {
        FB.init({
          appId: "{940042702999581}",
          xfbml: true,
          version: "v3.2",
        });

        // Get Embedded Video Player API Instance
        var my_video_player;
        FB.Event.subscribe("xfbml.ready", function(msg) {
          if (msg.type === "video") {
            my_video_player = msg.instance;
          }
        });
      };
    },
    async loadFacebookSDK(d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    },
    reproduceVideo(url) {
      return this.$youtube.getIdFromURL(url);
    },
    reproduceVideoF(url) {
      if (url == "") {
        url = news.link;
      }
      FB.XFBML.parse();
      return url;
    },
    loadNews() {
      let vm = this;

      this.overlay = true;

      news
        .doc(this.id)
        .get()
        .then((documentSnapshot) => {
          const news = documentSnapshot.data();
          this.news = {
            id: documentSnapshot.id,
            ...news,
          };

          if (news.link != undefined) {
            var linkYoutube = news.link.slice(0, 16);
            this.isYoutube = linkYoutube == "https://www.yout" ? true : false;
            this.urlF = linkYoutube == "https://www.yout" ? "" : news.link;
          }

          if (news.images) {
            for (let i = 0; i < news.images.length; i++) {
              vm.images[i].url = news.images[i];
            }
          }
        })
        .catch((error) => this.$emit("show-snackbar", error.message))
        .finally(() => (this.overlay = false));
    },
  },
};
</script>
<style scoped>
.container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.fb-video {
  width: 100% !important;
}
.sharedIcon:hover {
  cursor: pointer;
}
hr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #ccc;
  margin: 1em 0;
  padding: 0;
}
.videoNew {
  width: 100px !important;
}
</style>
